import type {
  IAvailabilityOptionDtoData,
  ICartPositionAvailabilityOptionsDtoData,
  IOciCustomerOrderMessageDtoData,
  IOrderCurrentDTOData
} from '~/dtos/ProdegaApiWebshop-api-typings-generated';
import type { CancelReasonType, PositionIntent, SendCartUserData } from '~/features/cart/state-machine/types';
import type { PROLIX_ERROR_IDENTIFIER } from '../../../common/types/prolixApplicationError';

export interface CartMessage {
  messageText: string | undefined; // Wenn prolixErrorIdentifier gesetzt ist sollte message undefined sein
  prolixError?: boolean;
  [PROLIX_ERROR_IDENTIFIER]?: string;
  traceId?: string;
}

export interface CartContextType {
  isInitialized: boolean;
  currentOrder: IOrderCurrentDTOData | undefined;
  completedOrderId: number | undefined;
  ociCustomerOrderMessage: IOciCustomerOrderMessageDtoData | undefined;
  positionIntents: PositionIntent[];
  scheduledPositionIntent: PositionIntent | undefined;
  desiredDeliveryDate: string | undefined;
  sendCartParams: SendCartUserData;
  cancelReasonId: CancelReasonType | undefined;
  cartMessages: CartMessage[];
  positionAvailabilityOptions: ICartPositionAvailabilityOptionsDtoData[] | undefined;
  selectedUserDialogOption: IAvailabilityOptionDtoData | undefined;
  isCsvImport: boolean | undefined;
  hasBackgroundCartReloadError: boolean;
  blockedPositionsDialogAcknowledgedForCartId: number | null;
}

export function createCartContext(): CartContextType {
  return {
    isInitialized: false,
    currentOrder: undefined,
    completedOrderId: undefined,
    ociCustomerOrderMessage: undefined,
    positionIntents: [],
    scheduledPositionIntent: undefined,
    desiredDeliveryDate: undefined,
    sendCartParams: { reference: '', remarks: '' },
    cancelReasonId: undefined,
    cartMessages: [],
    positionAvailabilityOptions: undefined,
    selectedUserDialogOption: undefined,
    isCsvImport: false,
    hasBackgroundCartReloadError: false,
    blockedPositionsDialogAcknowledgedForCartId: null
  };
}
